// The career and admission counsellor portals share every screen; these settings
// are the only differences between them.
export const COUNSELLOR_PORTALS = {
  career: {
    type: "career",
    basePath: "/counsellor-portal",
    apiPrefix: "counsellor-portal",
    storageKey: "counsellor-login-user",
    role: "Counsellor",
    label: "Counsellor",
    showEarnings: true,
  },
  admission: {
    type: "admission",
    basePath: "/admission-counsellor-portal",
    apiPrefix: "admission-counsellor-portal",
    storageKey: "admission-counsellor-login-user",
    role: "AdmissionCounsellor",
    label: "Admission Counsellor",
    showEarnings: false,
  },
};

// Used outside React (HTTP helpers), where the current URL tells us which portal is open.
export const getCurrentCounsellorPortal = () =>
  window.location.pathname.startsWith(COUNSELLOR_PORTALS.admission.basePath)
    ? COUNSELLOR_PORTALS.admission
    : COUNSELLOR_PORTALS.career;
